import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Target, Award, Hammer, Compass, ChevronRight } from 'lucide-react';

export default function About() {
  const points = [
    { text: "Experienced Workmanship", icon: Hammer },
    { text: "Quality-Focused Construction", icon: ShieldCheck },
    { text: "Reliable Structural Solutions", icon: Target },
    { text: "Professional Project Execution", icon: Award },
    { text: "Residential, Commercial & Industrial Expertise", icon: Compass }
  ];

  return (
    <section className="section about">
      <div className="container">
        <div className="about-split">
          {/* Left Column: Image with Experience Badge */}
          <div className="about-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80" 
              alt="Vijay Industry structural engineering project and PEB steel building fabrication in Coimbatore" 
              className="about-image"
              loading="lazy"
            />
            {/* Overlay Experience Badge */}
            <div className="about-experience-badge" aria-label="15 Years of Experience">
              <div className="about-exp-years">15+</div>
              <div className="about-exp-text">Years of Quality Excellence</div>
            </div>
          </div>

          {/* Right Column: Detailed Text & List */}
          <div className="about-content">
            <div className="section-header left-align" style={{ marginBottom: '1.5rem' }}>
              <span className="hero-eyebrow" style={{ display: 'block', marginBottom: '0.5rem' }}>About Us</span>
              <h2>Built With Strength. Delivered With Precision.</h2>
            </div>
            
            <p style={{ fontSize: '1.05rem', color: 'var(--muted)', marginBottom: '1.5rem' }}>
              Vijay Industry has established a solid reputation as a premier provider of heavy structural engineering 
              solutions. From pre-engineered structural steel warehouses to high-quality roofing, safety gates, and 
              ornamental stainless steel handrails, we take pride in delivering precise results.
            </p>
            
            {/* Checklist of features */}
            <div className="about-points" aria-label="Our core construction principles">
              {points.map((point, index) => {
                const IconComponent = point.icon;
                return (
                  <div key={index} className="about-point">
                    <div className="about-point-icon" aria-hidden="true">
                      <IconComponent size={16} />
                    </div>
                    <span className="about-point-text">{point.text}</span>
                  </div>
                );
              })}
            </div>

            {/* Section CTA */}
            <div style={{ marginTop: '1.5rem' }}>
              <Link 
                to="/contact" 
                className="btn btn-outline"
              >
                Discuss Your Project <ChevronRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
